<template>
  <div id="home_section" :class="{'gScroll': isWindows, 'mobile_view': isMobile}">
    <div id="about_background" :class="{'about_background_mobile': isMobile}" v-fragments>
      <img id="about_background_img" :src="this.isMobile ? require('../assets/about/dreammobile.png') : require('../assets/about/dreamer-sky.jpg')"/>
    </div>
    <div id="home_body_container">
      <div id="home_body" class="body">
        <div class="outer"><div class="middle"><div class="inner">
          <h1 ref="logo" id="logo">g</h1>
        </div></div></div>

        <div id="about">
          <div class="bodyInner" :class="{'bodyInner_m': isMobile}" id="about_text" ref="about_text">
            <p id="about_text_1" class="innerText" style="margin-right: 0; margin-top: 0;">CREATING A CULTURE OF</p>
            <div id="about_words" class="innerText centerText">
              <p id="fakeTxt" class="scroll_word_new noOpacity">INNOVATION</p>
              <p class="scroll_word_new">PHOTOGRAPHY</p>
              <p class="scroll_word_new">FILM</p>
              <p class="scroll_word_new">MUSIC</p>
              <p class="scroll_word_new">FASHION</p>
              <p class="scroll_word_new">INNOVATION</p>
            </div>
            <!-- <p class="innerText">INNOVATION</p> -->
            <p id="about_text_2" class="innerText" style="margin-left: 0; margin-top: 0;">FOR THE EVERYDAY DREAMER</p>
          </div>
        </div>

        <div id="about_email">CONTACT@GPRODUCTIONS.ORG</div>
        <!-- <div id="about_words"> -->
          <!-- <p class="scroll_word" style="margin-top: 0">PHOTOGRAPHY</p>
          <p class="scroll_word">FILM</p>
          <p class="scroll_word">MUSIC</p>
          <p class="scroll_word">FASHION</p>
          <p class="scroll_word">INNOVATION</p> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'

/* eslint-disable no-unused-vars */
/* eslint-disable no-constant-condition */
/* eslint-disable no-unreachable */
/* eslint-disable no-useless-escape */

export default {
  name: 'HOME',

  data: function() {
    return {
      gradient_progress: '0%',
      gradient_progress2: '0%',
      gradient_angle: '250deg',
      gradient_progress_val: 0,
      gradient_progress2_val: 0,
      gradient_angle_val: 280,
      loadAnimationTimeout: null,
      root: null,
      logo_iteration: 0,
      animation_id: -1,
      animation_id2: -1,
      scrollEnd: -1,
      about_animation_done: false,
      aboutScrollPercentages: [0.25, 0.37, 0.44, 0.51, 0.58, 0.65],
      currentAboutText: 0
    }
  },

  props: {
    pageMessages: Object,
    isMobile: Boolean,
    thisPage: Number,
    fixNav: Boolean,
    isWindows: Boolean,
  },

  directives: {
    fragments: {
      inserted: function(el) {
        var is_mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));
        if (!is_mobile) {
          const parent = document.getElementById('view');
          parent.insertBefore(el, parent.firstChild);
        } else {
          const parent = document.documentElement.getElementsByTagName('section');
          parent[0].insertBefore(el, parent[0].firstChild);
        }
        
      }
    }
  },

  created() {
    if (this.isMobile) {
      this.aboutScrollPercentages = [0.25, 0.3, 0.35, 0.4, 0.45, 0.5];
    }
  },

  mounted: async function() {
    this.root = document.documentElement;
    if (this.isMobile) {
      this.scrollEnd = document.getElementsByClassName('page')[0].offsetHeight - document.getElementById('home_section').offsetHeight;
    } else {
      this.scrollEnd = document.getElementById('home_body_container').offsetHeight - window.innerHeight;
    }
    
    this.loadAnimationTimeout = setInterval(this.logoAnimation.bind(this), 1000/60);
    if (this.isMobile) {
      document.addEventListener('scroll', this.scrollAnimation.bind(this));
    } else {
      document.getElementById('home_section').addEventListener('scroll', this.scrollAnimation.bind(this));
    }
    // window.addEventListener('resize', this.resizeUpdateHome);
    // await this.sleep(1000);
    // let emptySpaceBox = document.getElementsByClassName('innerText')[1].getBoundingClientRect();
    // let about_words_box = document.getElementById('about_words').getBoundingClientRect();
    // let left_val = (emptySpaceBox.width/2 + emptySpaceBox.left) - about_words_box.width/2;
    // document.getElementById('about_words').style.setProperty("left", left_val + "px");
    this.$root.$on(this.pageMessages[this.thisPage][0], this.scrolledTo);
    this.$root.$on(this.pageMessages[this.thisPage][1], this.scrolledAway);
  },

  methods: {
    sleep(milliseconds) {
      return new Promise(function(resolve, reject) {
        setTimeout(resolve, milliseconds, true);
      });
    },

    scrolledTo: async function() {
      if (this.isMobile) {
        return;
      }
      for (let elem of this.page().getElementsByTagName("p")) {
        elem.innerHTML = '';
      }
      for (let elem of this.page().getElementsByClassName("fade")) {
        elem.classList.remove("noOpacity");
      }
      await this.sleep(100);
      this.typewriter_effect();
    },

    scrolledAway: async function() {
      if (!this.isMobile) {
        document.getElementById('about_background').classList.add("fadeOut");
        document.getElementById('home_section').classList.add("fadeOut");
        await this.sleep(1000);
        document.getElementById('about_background').remove();
      }
      
    },

    logoAnimation() {
      if (this.gradient_angle_val > 0 && this.gradient_progress2_val < 500) {
        this.animation_id = requestAnimationFrame(this.logoAnimation.bind(this));
        this.logo_iteration += 1;
        if (this.gradient_angle_val <= 650) {
          this.gradient_angle_val += (330/(60 * 26));
          this.$refs.logo.style.setProperty("--gradient-angle", this.gradient_angle_val + "deg");
        } else { //  if (this.gradient_angle_val <= 730) {
          this.gradient_angle_val += (80/(60 * 24));
          this.$refs.logo.style.setProperty("--gradient-angle", this.gradient_angle_val + "deg");
        }
        
        this.gradient_progress2_val += (130/(60 * 26));
        this.gradient_progress_val = this.gradient_progress2_val - 100;
        
        this.$refs.logo.style.setProperty("--gradient-progress-2", this.gradient_progress2_val + "%");
      }
      // else if (this.gradient_progress2_val >= 130 && this.gradient_progress2_val < 500) {
      //   this.gradient_progress2_val += (370/(60 * 30));
      //   this.$refs.logo.style.setProperty("--gradient-progress", (this.gradient_progress2_val) + "%");
      // }
      else {
        this.stopAnimation();
      }
      // else if ( && this.gradient_angle_val > 320) {
      //   this.animation_id = requestAnimationFrame(this.logoAnimation.bind(this));
      //   this.gradient_progress_val += (200/(60 * 20));
      //   this.$refs.logo.style.setProperty("--gradient-progress", this.gradient_progress_val + "%");
      // }
      // if (this.gradient_angle_val <= 0 && this.gradient_progress2_val >= 100) {
      //   this.stopAnimation();
      // }
    },

    stopAnimation: async function() {
      // await this.sleep(5000);
      let old_timeout = this.loadAnimationTimeout;
      clearInterval(this.loadAnimationTimeout);
      cancelAnimationFrame(this.animation_id);
      cancelAnimationFrame(this.animation_id2);
    },

    aboutAnimation: async function() {
      if (this.about_animation_done) {
        return;
      }
      let text_height = document.getElementById("fakeTxt").offsetHeight;
      var texts = ["PHOTOGRAPHY", "FILM", "MUSIC", "FASHION", "INNOVATION"];
      for (let i=0; i<texts.length; i++) {
        let new_text = document.createElement("p");
        new_text.innerText = texts[i];
        new_text.classList.add("scroll_word_new");
        document.getElementById("about_words").appendChild(new_text);
        await this.sleep(50);
        var all_texts = document.getElementsByClassName("scroll_word_new");
        let transition_time = 0.4;
        // if (texts.length - 1 - i <= 2) {
        //   transition_time =  (2 - (texts.length - 1 - i)) * 0.2;
        //   for (let t of all_texts) {
        //     t.style.setProperty("transition", "all " + transition_time + "s ease"); 
        //   }
        // }
        if (i > 0) {
          // all_texts[all_texts.length - 2].classList.add("scroll_word_top");
          all_texts[all_texts.length - 2].style.setProperty("top", (-1 * text_height * (i+1)) + "px");
          all_texts[all_texts.length - 2].style.setProperty("opacity", "0");
        }

        all_texts[all_texts.length - 1].style.setProperty("top", (-1 * text_height * (i+1)) + "px");
        all_texts[all_texts.length - 1].style.setProperty("opacity", "1");
        
        // all_texts[all_texts.length - 1].classList.add("scroll_word_center");
        await this.sleep(transition_time * 1000);
      }

      this.about_animation_done = true;
      let new_text = document.createElement("p");
      new_text.classList("innerText");
      // document.getElementsByClassName("innerText")[1].classList.add("visible");
      // all_texts[all_texts.length - 1].classList.add("noOpacity");
      // await this.sleep(100);
      // all_texts[all_texts.length - 1].style.setProperty("display", "none !important");
    },

    aboutAnimation2: async function(x) {
      let old_text = this.currentAboutText;
      this.currentAboutText = x;
      let text_height = document.getElementById("fakeTxt").offsetHeight;
      var all_texts = document.getElementsByClassName("scroll_word_new");
      var px_height = text_height * x;
      if (!this.isMobile) {
        px_height += (0.4 * x)
      }

      if (x > old_text) {
        for(let z=old_text; z<x; z++) {
          if (x > 0) {
            all_texts[z].style.setProperty("top", (-1 * text_height * x) + "px");
            all_texts[z].style.setProperty("opacity", "0");
          }
        }
        all_texts[x].style.setProperty("top", (-1 * px_height) + "px");
        all_texts[x].style.setProperty("opacity", "1");
        
      }
      else if (x < old_text) {
        for(let z=old_text; z>x; z--) {
          if (x < 5) {
            all_texts[z].style.setProperty("top", (-1 * text_height * x) + "px");
            all_texts[z].style.setProperty("opacity", "0");
          }
        }

        if (x != 0) {
          all_texts[x].style.setProperty("top", (-1 * px_height) + "px");
          all_texts[x].style.setProperty("opacity", "1");
        } else {
          all_texts[x].style.removeProperty("top");
        }
        
      } else {
        return;
      }
    },

    scrollAnimation: async function() {
      // this.animation_id = requestAnimationFrame(this.scrollAnimation.bind(this));
      let scrollPercentage;
      if (!this.isMobile) {
        scrollPercentage = document.getElementById('home_section').scrollTop/this.scrollEnd;
      } else {
        scrollPercentage = document.scrollingElement.scrollTop/this.scrollEnd;
      }
      
      // let scrollPercentage = window.scrollY/this.scrollEnd;
      if (scrollPercentage <= 0.05) {
        let logo_percentage = scrollPercentage/0.05;
        let gradient_progress2 = 100 + (logo_percentage * 100);
        let gradient_progress = 100 - (logo_percentage * 98);
        let gradient_angle_val = 0;
        document.getElementById('logo').style.setProperty("--gradient-angle", gradient_angle_val + "deg");
        document.getElementById('logo').style.setProperty("--gradient-progress-2", gradient_progress2 + "%");
        document.getElementById('logo').style.setProperty("--gradient-progress", gradient_progress + "%");
      }

      if (scrollPercentage <= 0.15 && scrollPercentage >= 0.05) {
        let logo_percentage = (scrollPercentage - 0.05)/(0.10);
        // console.log(logo_percentage);
        let gradient_progress2 = 200 - (logo_percentage * 100);
        // let gradient_progress = 100 - ((logo_percentage * 100));
        let gradient_progress = 2 + (logo_percentage * 50);
        // let gradient_angle_val = 180;
        document.getElementById('logo').style.setProperty("--gradient-progress-2", gradient_progress2 + "%");
        document.getElementById('logo').style.setProperty("--gradient-progress", gradient_progress + "%");
      }

      if (scrollPercentage >= 0.05 && scrollPercentage <= 0.15) {
        let logo_percentage = (scrollPercentage - 0.05)/(0.10);
        let gradient_angle_val = 0 + (logo_percentage * 200);
        document.getElementById('logo').style.setProperty("--gradient-angle", gradient_angle_val + "deg");
      }

      if (scrollPercentage <= 0.14) {
        let logo_fade_percentage = (scrollPercentage)/0.14;
        let fade_val = 1 - logo_fade_percentage;
        let scale_val = 3 - (logo_fade_percentage * (0.7));
        document.getElementById('logo').style.setProperty("opacity", Math.max(fade_val, 0));
        document.getElementById('logo').style.setProperty("font-size",  scale_val  + "rem");
      }


      
      var about_text_percentage_I = (scrollPercentage - 0.05)/0.15;
      if (scrollPercentage >= 0.05 && scrollPercentage <= 0.30) {
        let about_text_gp2 = Math.floor(about_text_percentage_I * 100);
        let about_text_gp = Math.floor(about_text_gp2/2);
        if (about_text_gp == 1) {
          about_text_gp = 0;
          about_text_gp2 = 0;
        }
        document.getElementById('about_text_1').style.setProperty("--gradient-progress-2", about_text_gp2 + "%");
        document.getElementById('about_text_1').style.setProperty("--gradient-progress", about_text_gp + "%");
      }

      if (scrollPercentage >= 0.2 && scrollPercentage <= 0.50 && about_text_percentage_I >= 1) {
        let about_text_percentage = (scrollPercentage - 0.2)/0.15;
        let about_text_gp2 = Math.floor(about_text_percentage * 100);
        let about_text_gp = Math.floor(about_text_gp2/2);
        if (about_text_gp == 1) {
          about_text_gp = 0;
        }
        document.getElementById('about_text_2').style.setProperty("--gradient-progress-2", about_text_gp2 + "%");
        document.getElementById('about_text_2').style.setProperty("--gradient-progress", about_text_gp + "%");
      }

      if (about_text_percentage_I < 1) {
        document.getElementById('about_text_2').style.setProperty("--gradient-progress-2", 0 + "%");
        document.getElementById('about_text_2').style.setProperty("--gradient-progress", 0 + "%");
      }

      if (scrollPercentage > 0.15 && scrollPercentage <= 0.55) {
        let about_img_percentage = (scrollPercentage - 0.15)/0.4;
        document.getElementById('about_background_img').style.setProperty("filter", "brightness(" + Math.min(about_img_percentage, 0.429295) + ")");
      }

      let aboutScroll = false;
      for (let x=0; x<this.aboutScrollPercentages.length; x++) {
        if (parseFloat(scrollPercentage.toFixed(2)) == this.aboutScrollPercentages[x]) {
          this.aboutAnimation2(x);
        }
      }

      if (parseFloat(scrollPercentage.toFixed(2)) < this.aboutScrollPercentages[0]) {
        this.aboutAnimation2(0);
      }
      else if (parseFloat(scrollPercentage.toFixed(2)) > this.aboutScrollPercentages[5]) {
        this.aboutAnimation2(5);
      }

      if (scrollPercentage >= 0.6 && !this.isMobile) {
        let nav_bar_percentage = (scrollPercentage-0.6)/0.2;
        document.getElementById('navbarLP').style.setProperty("bottom", Math.min((-4 + (4 * nav_bar_percentage)), 0) + "vh");
      }
      // if (scrollPercentage >= 0.8) {
      //   let about_img_percentage = (scrollPercentage - 0.8)/0.2;
      //   document.getElementById('about_background').style.setProperty("opacity", 0.433009 - (about_img_percentage * 0.433009));
      // }

      // if (scrollPercentage >= 0.4 && scrollPercentage <= 0.9) {
      //   let current_word = Math.floor((scrollPercentage - 0.4)/0.1);
      //   console.log("CURRENT WORD: " + current_word);
      //   let current_word_percentage = (scrollPercentage - 0.4 - (current_word * 0.1)) * 10;
      //   let translate_height = window.innerHeight * 0.07;
      //   let og_top = window.innerHeight * 0.5;
      //   if (current_word_percentage <= 0.3) {
      //     let inner_percentage = current_word_percentage/0.3;
      //     document.getElementsByClassName("scroll_word")[current_word].style.setProperty("opacity", Math.min(current_word_percentage/0.3, 1));

      //     if (current_word > 0) {
      //       let extra_length = document.getElementsByClassName("scroll_word")[current_word - 1].getBoundingClientRect().height;
      //       let translate = (og_top - (translate_height * current_word) - ((current_word - 1) * extra_length)) - ((translate_height + extra_length) * inner_percentage);
      //       console.log("TRANS: " + translate);
      //       document.getElementById("about_words").style.setProperty("top", translate + "px");
      //       if (inner_percentage >= 0.9) {
      //         document.getElementsByClassName("scroll_word")[current_word - 1].style.setProperty("opacity", 0);
      //       } else {
      //         document.getElementsByClassName("scroll_word")[current_word - 1].style.setProperty("opacity", 1 - Math.min(inner_percentage, 1));
      //       }
            
      //     } else {
      //       let translate = og_top - (translate_height * inner_percentage);
      //       document.getElementById("about_words").style.setProperty("top", translate + "px");
      //     }
      //   }
        // else (current_word_percentage > 0.3 && current_word_percentage <= 0.7) {
        //   console.log("STAYING");
        // } 
        // else {
        //   document.getElementsByClassName("scroll_word")[current_word].style.setProperty("opacity", 1 - Math.max((current_word_percentage-0.7)/0.3, 0));
        //   document.getElementById("about_words").style.setProperty("top", og_top - ((translate_height * current_word) + (translate_height * ((current_word_percentage-0.7)/0.3)) + translate_height) + "px");
        // }
      // }

    }


  }
}
</script>

<style>
@font-face { font-family: monaco; src: url('/fonts/monaco.ttf'); }
@font-face { font-family: gfont; src: url('/fonts/Gproductions.otf'); }
@font-face { font-family: gfont2; src: url('/fonts/Gproductions2.otf'); }

@font-face { font-family: monaco2; src: url('../assets/fonts/monaco.ttf'); }
@font-face { font-family: gfont2; src: url('../assets/fonts/Gproductions.otf'); }
@font-face { font-family: gfont22; src: url('../assets/fonts/Gproductions2.otf'); }

.scroll_word_new {
  opacity: 0;
  font-family: monaco, monaco2;
  background: transparent;
  color: white;
  -webkit-font-smoothing: none;
  letter-spacing: 4px;
  text-align: center;
  width: 100%;
  transition: 0.3s;
  position: relative;
  vertical-align: middle;
  margin-bottom: 0;
}

.scroll_word_center {
  top: 0vh;
  opacity: 1;
}

.scroll_word_top {
  top: -7vh;
  opacity: 0;
}

.noOpacity {
  opacity: 0;
  transition: 0.1s;
}

.visible {
  opacity: 1 !important;
}

.centerText {
  padding-left: 4px;
  padding-right: 4px;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.fadeOut {
  opacity: 0;
  transition: 1s ease;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
  /* background: black; */
  position: relative;
  height: 300vh;
  width: 100vw;
}

.outer {
	display: table;
	position: relative;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100%;
}
  
.middle {
	display: table-cell;
	vertical-align: middle;
}
  
.inner {
	margin-left: auto;
	margin-right: auto;
	/* width: fit-content; */
	position: relative;
	/*whatever width you want*/
}

#about_text_1 {
  height: -webkit-fit-content;
  text-align: center;
  --gradient-progress: 0%;
  --gradient-progress-2: 0%;
  --gradient-angle: 100deg;
  --gradient-color: 255;
  --gradient-color-2: 240;
  --gradient-opacity: 1;
  --gradient-opacity-2: 0;
  background-image: linear-gradient(var(--gradient-angle), rgba(var(--gradient-color), var(--gradient-color), var(--gradient-color), var(--gradient-opacity)) var(--gradient-progress), rgba(var(--gradient-color-2), var(--gradient-color-2), var(--gradient-color-2), var(--gradient-opacity-2)) var(--gradient-progress-2));
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  width: -moz-min-content;
  -webkit-font-smoothing: none;
}

#about_text_2 {
  height: -webkit-fit-content;
  text-align: center;
  --gradient-progress: 0%;
  --gradient-progress-2: 0%;
  --gradient-angle: 100deg;
  --gradient-color: 255;
  --gradient-color-2: 240;
  --gradient-opacity: 1;
  --gradient-opacity-2: 0;
  background-image: linear-gradient(var(--gradient-angle), rgba(var(--gradient-color), var(--gradient-color), var(--gradient-color), var(--gradient-opacity)) var(--gradient-progress), rgba(var(--gradient-color-2), var(--gradient-color-2), var(--gradient-color-2), var(--gradient-opacity-2)) var(--gradient-progress-2));
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  width: -moz-min-content;
  -webkit-font-smoothing: none;
}

.bodyInner {
  color: white;
  height: -webkit-fill-available;
  transition: 0.5s !important;
  width: 100%;
  height: -webkit-fit-content;
  display: flex;
  text-align: center;
  width: -moz-min-content;
  letter-spacing: 2px;
}

.bodyInner_m {
  letter-spacing: 1.5px !important;
  font-size: 0.8rem !important;
}

.fade {
  transition: 0.5s ease;
}

.outer1 {
  position: absolute;
  top: 20%;
}

p.inner1_1 {
    margin: 0;
    font-size: 1.2rem;
}

p.inner1_2 {
    margin: 0;
    font-size: 1.5rem;
}

.outer2 {
  position: absolute;
  top: 45%;
  text-align: right;
  font-size: 1rem;
  right: 2%;
}

.outer3 {
    position: absolute;
    bottom: 10%;
}

.outer3 p {
  margin: 1rem !important;
}

p {
  margin: auto;
}

#innerText {
  vertical-align: middle;
  text-align: center;
  position: -webkit-sticky;
  position: sticky;
  top: 50%;
}

#about {
  /* height: 100vh; */
  position: sticky;
  font-family: monaco, monaco2;
  background: transparent;
  top: 50vh;
  height: fit-content;
}

#about_words {
  position: -webkit-sticky;
  position: sticky;
  font-family: monaco, monaco2;
  background: transparent;
  /* top: 0vh; */
  /* height: 100vh; */
  width: 8rem;
  color: white;
  -webkit-font-smoothing: none;
  letter-spacing: 3px;
  /* width: fit-content; */
  /* left: 43.5%; */
  text-align: center;
  transition: 0.1s;
  height: fit-content;
  vertical-align: middle;
}

/* p.scroll_word {
  margin-top: 7vh;
  opacity: 0;
  transition: 0.3s;
  position: relative;
} */



/* #about_background {
  width: 100vw;
  height: auto;
  overflow: hidden;
  position: sticky;
  top: 0;
} */

/* #about_background img {
  width: inherit;
  height: auto;
} */

#logo {
  color: white;
  text-align: center;
  font-size: 3rem;
  font-family: gfont2, gfont22;
  position: relative;
  --gradient-color: 0;
  --gradient-color-2: 0;
  --gradient-opacity: 0;
  --gradient-opacity-2: 1;
  --gradient-progress: 0%;
  --gradient-progress-2: 0%;
  --gradient-angle: 250deg;
  --gradient-color: 255;
  --gradient-color-2: 240;
  --gradient-opacity: 1;
  --gradient-opacity-2: 0;
  background-image: linear-gradient(var(--gradient-angle), rgba(var(--gradient-color), var(--gradient-color), var(--gradient-color), var(--gradient-opacity)) var(--gradient-progress), rgba(var(--gradient-color-2), var(--gradient-color-2), var(--gradient-color-2), var(--gradient-opacity-2)) var(--gradient-progress-2));
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  width: min-content;
  margin: auto;
  -webkit-font-smoothing: antialiased;
  transform: 0.1s;
  font-weight: 100;
}

#about_background {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: sticky; 
  top: 0;
  transform: 0.1s;
}

#about_background img {
  width: inherit;
  height: auto;
  position: relative;
  filter: brightness(0);
  /* top: -25%; */
}

.about_background_mobile {
  width: 100% !important;
  height: unset !important;
  position: absolute !important;
  top: 104vw !important;
  filter: blur(0px);
}

.about_background_mobile img {
  /* width: unset !important;
  height: unset !important; */
}

#home_section {
  width: inherit;
  overflow-y: scroll;
  overflow-x: hidden;
  position: absolute;
  height: inherit;
  top: 0;
}

.mobile_view {
  display: contents;
}

/* #home_section::-webkit-scrollbar {
	width: 3px !important;
}
  
#home_section::-webkit-scrollbar-track {
	border-radius: 3px !important;
}
  
#home_section::-webkit-scrollbar-thumb {
	background: whitesmoke !important;
} */

#about_email {
  text-align: center;
  color: whitesmoke;
  font-family: monaco, monaco2;
  letter-spacing: 3px;
  -webkit-font-smoothing: none;
  position: sticky;
  top: 90vh;
  font-size: 1rem;
  opacity: 0;
}

@media (max-width:481px) {
  #about_words {
    position: -webkit-sticky;
    position: sticky;
    font-family: monaco, monaco2;
    background: transparent;
    /* top: 0vh; */
    /* height: 100vh; */
    width: -webkit-min-content;
    color: white;
    -webkit-font-smoothing: none;
    letter-spacing: 1.5px !important;
    /* width: fit-content; */
    /* left: 43.5%; */
    text-align: center;
    transition: 0.1s;
    height: fit-content;
    vertical-align: middle;
    font-weight: 700;
  }

  .bodyInner_m {
    letter-spacing: 1.5px !important;
    font-size: 0.7rem !important;
  }

}
</style>
